/** Legal copy aligned with WasOK `docs/PRIVACY_POLICY.md` / `docs/TERMS_OF_SERVICE.md`. */
export const legalMessagesCs = {
  privacy: {
    pageTitle: "Zásady ochrany osobních údajů",
    lastUpdated: "Poslední aktualizace: 1. června 2026",
    introduction: {
      title: "Úvod",
      body: "WasOK je lokálně orientovaná nákupní pomocná aplikace navržená tak, aby uživatelům pomáhala pamatovat si produkty, které dříve koupili, ohodnotili nebo zrecenzovali.\n\nTyto zásady ochrany osobních údajů vysvětlují, jaké informace se při používání aplikace zpracovávají, jak se data ukládají a jak mohou fungovat některé služby třetích stran.",
    },
    dataStored: {
      title: "Data ukládaná aplikací",
      body: "WasOK ukládá následující informace lokálně ve vašem zařízení:\n\n• naskenované čárové kódy produktů\n• názvy produktů a podrobnosti zadané uživatelem\n• hodnocení a komentáře\n• nákupní seznamy\n• kategorie produktů\n• ceny a informace o obchodech\n• fotografie produktů a obchodů\n\nVaše produktová data a fotografie se nenahrávají na servery WasOK.",
    },
    permissions: {
      title: "Používaná oprávnění",
      camera: {
        title: "Fotoaparát",
        body: "Přístup k fotoaparátu se používá pro:\n\n• skenování čárových kódů\n• pořizování fotografií produktů",
      },
      photos: {
        title: "Fotografie a média",
        body: "Přístup k fotografiím nebo galerii se používá pouze když:\n\n• připojujete obrázky k produktům\n• obnovujete zálohy obsahující fotografie",
      },
      files: {
        title: "Přístup k souborům a úložišti",
        body: "Přístup k souborům může být použit pro:\n\n• export záložních souborů\n• import záloh vybraných uživatelem\n• sdílení nákupních seznamů nebo záloh",
      },
    },
    backup: {
      title: "Funkce zálohování a exportu",
      body: "WasOK umožňuje uživatelům vytvářet záložní soubory obsahující data aplikace a volitelně fotografie.\n\nZáložní soubory se vytvářejí lokálně ve vašem zařízení a mohou být uloženy nebo sdíleny pomocí služeb vybraných uživatelem, například:\n\n• Google Drive\n• Dropbox\n• iCloud Drive\n• místní úložiště zařízení\n\nWasOK nenahrává zálohy na vlastní servery.",
      onlineProductLookup: {
        title: "Online vyhledávání produktů",
        body: "Když v Nastavení povolíte online vyhledávání čárových kódů, může WasOK odeslat pouze naskenované číslo čárového kódu do veřejných produktových databází (například Open Food Facts), aby navrhl název produktu a značku. WasOK pro tuto funkci nenahrává vaše hodnocení, komentáře, fotografie, nákupní seznamy, kategorie, informace o obchodech ani záložní data. Tuto funkci můžete kdykoli vypnout v Nastavení.",
      },
    },
    advertising: {
      title: "Reklama a služby třetích stran",
      intro:
        "WasOK používá vybrané služby třetích stran k poskytování určitých funkcí.",
      admob: {
        title: "Google AdMob",
        body: "Google AdMob se používá k zobrazování reklam v aplikaci.\n\nGoogle a jeho partneři mohou zpracovávat informace jako:\n\n• reklamní identifikátory\n• informace o zařízení\n• IP adresa\n• diagnostické a uživatelské informace\n\nUživatelé v některých regionech mohou být požádáni o souhlas před zobrazením personalizovaných reklam.",
      },
      crashlytics: {
        title: "Firebase Crashlytics",
        body: "WasOK používá Firebase Crashlytics k identifikaci pádů a zlepšení stability aplikace.\n\nHlášení o pádech mohou obsahovat technické informace jako:\n\n• model zařízení\n• verze operačního systému\n• verze aplikace\n• diagnostika pádů\n\nHlášení o pádech záměrně neobsahují vaše hodnocení produktů, poznámky, nákupní seznamy ani fotografie.",
      },
      externalProductDatabases: {
        title: "Externí produktové databáze",
        body: "Funkce vyhledávání čárových kódů může používat externí produktové databáze k získání informací o produktech.\n\nDalší informace naleznete v zásadách ochrany osobních údajů příslušných poskytovatelů.",
      },
    },
    dataSecurity: {
      title: "Zabezpečení dat",
      body: "WasOK ukládá data aplikace lokálně ve vašem zařízení pomocí úložných mechanismů poskytovaných operačním systémem.\n\nAčkoli jsou přijímána přiměřená opatření k ochraně místních dat aplikace, žádná metoda elektronického úložiště není zcela bezpečná.\n\nUživatelé jsou odpovědní za udržování záloh důležitých dat, pokud si to přejí.",
    },
    children: {
      title: "Ochrana soukromí dětí",
      body: "WasOK není určen dětem mladším 13 let.",
    },
    notifications: {
      title: "Oznámení",
      body: "WasOK může volitelně vytvářet místní oznámení ve vašem zařízení, která vám připomenou ohodnotit produkty po nákupu.\n\nTato oznámení se generují a plánují lokálně ve vašem zařízení a nevyžadují účet ani vzdálený server.\n\nOznámení můžete kdykoli vypnout v nastavení zařízení nebo v aplikaci, pokud je to podporováno.",
    },
    yourControl: {
      title: "Vaše kontrola nad daty",
      body: "Můžete:\n\n• kdykoli upravit nebo smazat uložené produkty\n• vymazat data aplikace ze zařízení\n• odinstalovat aplikaci\n• exportovat zálohy svých dat",
    },
    changes: {
      title: "Změny těchto zásad",
      body: "Tyto zásady ochrany osobních údajů mohou být čas od času aktualizovány.\n\nZměny nabývají účinnosti zveřejněním aktualizované verze.",
    },
    contact: {
      title: "Kontakt",
      body: "Máte-li dotazy ohledně těchto zásad ochrany osobních údajů, kontaktujte:\n\nsupport@wasok.app",
    },
  },
  terms: {
    pageTitle: "Podmínky služby",
    lastUpdated: "Poslední aktualizace: 1. června 2026",
    acceptance: {
      title: "Přijetí podmínek",
      body: "Stažením, instalací nebo používáním WasOK souhlasíte s těmito podmínkami služby.\n\nPokud s těmito podmínkami nesouhlasíte, neměli byste aplikaci používat.",
    },
    license: {
      title: "Licence",
      body: "WasOK vám uděluje omezenou, nevýhradní, nepřenositelnou a odvolatelnou licenci k používání aplikace v souladu s těmito podmínkami.",
    },
    acceptableUse: {
      title: "Přípustné použití",
      body: "Souhlasíte, že nebudete:\n\n• aplikaci zneužívat\n• zasahovat do provozu aplikace\n• pokoušet se o zpětnou analýzu nebo úpravu aplikace\n• používat aplikaci v rozporu s platnými zákony nebo předpisy",
    },
    localData: {
      title: "Místní data a zálohy",
      body: "WasOK ukládá uživatelská data lokálně v zařízení.\n\nUživatelé jsou odpovědní za udržování záloh důležitých dat, pokud si to přejí.\n\nAčkoli může být k dispozici funkce zálohování a obnovení, WasOK negarantuje ochranu proti ztrátě, poškození nebo selhání uložených dat.",
    },
    advertisements: {
      title: "Reklamy",
      body: "Aplikace může zobrazovat reklamy poskytované reklamními partnery třetích stran, včetně Google AdMob.",
    },
    noWarranty: {
      title: "Bez záruky",
      body: "WasOK je poskytován „tak, jak je“ a „jak je k dispozici“ bez záruk jakéhokoli druhu, výslovných ani předpokládaných.\n\nNegarantujeme, že:\n\n• aplikace bude vždy dostupná\n• aplikace bude bezchybová\n• nikdy nedojde ke ztrátě dat\n• všechny funkce budou nepřerušovaně fungovat na všech zařízeních",
    },
    limitationLiability: {
      title: "Omezení odpovědnosti",
      body: "V maximálním rozsahu povoleném zákonem WasOK a jeho vývojáři nenesou odpovědnost za:\n\n• ztrátu dat\n• ztrátu zisku\n• problémy se zařízením\n• nepřímé nebo následné škody\n• přerušení vyplývající z používání nebo neschopnosti používat aplikaci",
    },
    thirdParty: {
      title: "Služby třetích stran",
      body: "Určité funkce nebo obsah mohou záviset na službách třetích stran, včetně poskytovatelů reklamy a externích služeb úložiště/sdílení vybraných uživatelem.\n\nWasOK nenese odpovědnost za služby třetích stran ani jejich zásady.",
    },
    productInformation: {
      title: "Informace o produktech",
      body: "Určité podrobnosti o produktech mohou být získány ze služeb vyhledávání čárových kódů třetích stran.\n\nWasOK negarantuje přesnost, úplnost, dostupnost ani vhodnost informací poskytovaných externími zdroji dat.\n\nUživatelé by měli informace o produktech v případě potřeby ověřit samostatně.",
    },
    changesApp: {
      title: "Změny aplikace",
      body: "WasOK může být kdykoli bez předchozího upozornění upraven, aktualizován, pozastaven nebo ukončen.",
    },
    changesTerms: {
      title: "Změny těchto podmínek",
      body: "Tyto podmínky mohou být pravidelně aktualizovány.\n\nPokračující používání aplikace po nabytí účinnosti aktualizací představuje přijetí revidovaných podmínek.",
    },
    contact: {
      title: "Kontakt",
      body: "S dotazy ohledně těchto podmínek kontaktujte:\n\nsupport@wasok.app",
    },
  },
};
